import { render, staticRenderFns } from "./DataFModelIntra.vue?vue&type=template&id=25da48e8&scoped=true"
import script from "./DataFModelIntra.vue?vue&type=script&lang=js"
export * from "./DataFModelIntra.vue?vue&type=script&lang=js"
import style0 from "./DataFModelIntra.vue?vue&type=style&index=0&id=25da48e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25da48e8",
  null
  
)

export default component.exports